<template>
  <v-app  class="dd secondary darken-1 h-100 scroll-y">
      <div class="ddd">
        <router-view/>
      </div>
  </v-app>
</template>

<script>
/* eslint-disable */
export default {
  name: "App",
  mounted:function(){
        var config = {
          messagingSenderId: "1087400853618"
        };
        firebase.initializeApp(config);
        const messaging = firebase.messaging();

        // Request for permission
        messaging.requestPermission()
        .then(function() {
          console.log('Notification permission granted.');
          // TODO(developer): Retrieve an Instance ID token for use with FCM.
          messaging.getToken()
          .then(function(currentToken) {
            if (currentToken) {
              console.log('Token: ' + currentToken)
              localStorage.setItem('device_token',currentToken)
            } else {
              console.log('No Instance ID token available. Request permission to generate one.');
            }
          })
          .catch(function(err) {
            console.log('An error occurred while retrieving token. ', err);
          });
        })
        .catch(function(err) {
          console.log('Unable to get permission to notify.', err);
        });


        messaging.onMessage(function(payload) {
          console.log("Notification received: ", payload);
          Store.dispatch('Notifications/pushLiveNotification',payload.data)
        });

      // var el = document.getElementById('#notificationWindow')
      // console.log(el)
      // el.scrollTop = el.scrollHeight

      // this.pusher=new Pusher('e9455c16bc5f0d6c4547',{
      //   cluster: 'ap2',
      //   encrypted: true,
      //   disableStats: true,
      // })
      // let self=this
      // let pusherToken=Store.state.pusherToken
      //  this.channel=this.pusher.subscribe(pusherToken);
      // let notificationData=Store.state.notificationData
  }
};

</script>
<style>
@import "./css/main.css";
/*@import "./assets/css/main.css";*/
.v-input--selection-controls__input .fa, .fas, .far, .fal, .fab{
  font-size: 15px !important;
  /*margin-top: 10px !important;*/
  /*margin-right: 0px !important;*/
}
.material-icons {
  /*font-size: 20px !important;*/
}
  /*.dd{*/
    /*background-image: url("https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg")!important;*/
    /*width: 100%!important;*/
    /*height: 100%!important;*/
    /*background-repeat: no-repeat!important;*/
    /*overflow-y: scroll!important;*/
    /*background-position: center!important;*/
    /*background-size: cover!important;*/
  /*}*/
  /*.ddd {*/
    /*width: 100% !important;*/
    /*background-color: rgba(0, 0, 0, 0.64) !important;*/
    /*height: 100% !important;*/
    /*overflow-y: scroll !important;*/
  /*}*/
  /*::-webkit-scrollbar{*/
    /*display: none!important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue